// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2879, 158, 255, 1%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dark Theme Styles */
body {
  background-color: #0f1419 !important;
  color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.App {
  min-height: 100vh;
  background: linear-gradient(135deg, #0f1419 0%, #1a1d29 50%, #2d3343 100%);
  min-height: 100vh;
}

/* Authentication Background */
.auth-background {
  /* background: linear-gradient(135deg, #0f1419 0%, #1a1d29 50%, #2d3343 100%);
  min-height: 100vh; */
}

/* Custom Form Controls */
.form-control:focus {
  background-color: #2d3343 !important;
  border-color: #4f9eff !important;
  box-shadow: 0 0 0 0.2rem rgba(79, 158, 255, 0.25) !important;
  color: #fff !important;
}

.form-control::placeholder {
  color: #8d99ae !important;
}

/* Custom Button Styles */
.btn-primary {
  background-color: #4f9eff;
  border-color: #4f9eff;
}

.btn-primary:hover {
  background-color: #3d7acc;
  border-color: #3d7acc;
}

.btn-primary:focus {
  box-shadow: 0 0 0 0.2rem rgba(79, 158, 255, 0.5);
}

/* Navbar Styles */
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.85);
  transition: color 0.3s ease;
}

.navbar-dark .navbar-nav .nav-link:hover {
  color: #4f9eff;
}

/* Card Hover Effects */
.card {
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
}

/* Table Styles */
.table-dark {
  --bs-table-bg: #1a1d29;
  --bs-table-striped-bg: #2d3343;
  --bs-table-hover-bg: #2d3343;
}

/* Badge Styles */
.badge {
  font-size: 0.75em;
}

/* Profile Picture Styles */
.profile-picture-container {
  position: relative;
  display: inline-block;
}

.profile-picture-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 50%;
  cursor: pointer;
}

.profile-picture-container:hover .profile-picture-overlay {
  opacity: 1;
}

/* Background Image Upload */
.background-upload-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  cursor: pointer;
}

.background-image-container:hover .background-upload-overlay {
  opacity: 1;
}

/* Modal Styles */
.modal-content {
  background-color: #1a1d29 !important;
  border: 1px solid #2d3343 !important;
}

.modal-header {
  border-bottom: 1px solid #2d3343 !important;
}

.btn-close {
  filter: invert(1);
}

/* Username Validation Styles */
.username-input-success {
  border-color: #28a745 !important;
}

.username-input-error {
  border-color: #dc3545 !important;
}

/* Loading Spinner */
.spinner-border-light {
  border-color: rgba(255, 255, 255, 0.25);
  border-right-color: #4f9eff;
}

/* Profile Stats */
.profile-stats {
  padding: 1rem 0;
  border-top: 1px solid #2d3343;
  border-bottom: 1px solid #2d3343;
}

.profile-stat {
  text-align: center;
  padding: 0 1rem;
}

.profile-stat h5 {
  margin-bottom: 0.25rem;
  font-weight: bold;
}

.profile-stat small {
  color: #8d99ae;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .navbar-brand {
    font-size: 1rem;
  }
  
  .card-body {
    padding: 1rem;
  }
  
  h2 {
    font-size: 1.5rem;
  }

  .profile-picture-container img {
    width: 100px !important;
    height: 100px !important;
  }

  .background-image-container {
    height: 150px !important;
  }
}

/* Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card, .alert {
  animation: fadeIn 0.5s ease-out;
}

/* Custom Scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #1a1d29;
}

::-webkit-scrollbar-thumb {
  background: #4f9eff;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #3d7acc;
}

/* File Input Styling */
.form-control[type="file"] {
  background-color: #2d3343 !important;
  border-color: #4f9eff !important;
  color: #fff !important;
}

.form-control[type="file"]::-webkit-file-upload-button {
  background-color: #4f9eff;
  border: none;
  color: white;
  padding: 0.375rem 0.75rem;
  border-radius: 0.375rem;
  margin-right: 0.75rem;
  cursor: pointer;
}

.form-control[type="file"]::-webkit-file-upload-button:hover {
  background-color: #3d7acc;
  border-color: #3d7acc;
}

/* Navigation Responsive Styles */
.navbar-toggler {
  border: none !important;
  padding: 0.25rem 0.5rem;
}

.navbar-toggler:focus {
  box-shadow: none !important;
}

.navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

/* Mobile Navigation Improvements */
@media (max-width: 991.98px) {
  .navbar-collapse {
    background-color: #1a1d29;
    padding: 1rem;
    margin-top: 0.5rem;
    border-radius: 8px;
    border: 1px solid #2d3343;
  }
  
  .navbar-nav {
    padding-bottom: 1rem;
    border-bottom: 1px solid #2d3343;
    margin-bottom: 1rem;
  }
  
  .navbar-nav .nav-link {
    padding: 0.75rem 1rem;
    border-radius: 6px;
    margin-bottom: 0.25rem;
  }
  
  .navbar-nav .nav-link:hover {
    background-color: #2d3343;
  }
  
  .navbar-nav .nav-link.fw-bold {
    background-color: #4f9eff;
    color: white !important;
  }
}

/* Dashboard Tab Navigation */
.dashboard-tabs {
  overflow-x: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}

.dashboard-tabs::-webkit-scrollbar {
  height: 4px;
}

.dashboard-tabs::-webkit-scrollbar-track {
  background: #1a1d29;
}

.dashboard-tabs::-webkit-scrollbar-thumb {
  background: #4f9eff;
  border-radius: 4px;
}

@media (max-width: 768px) {
  .dashboard-tabs .btn {
    white-space: nowrap;
    min-width: auto;
    font-size: 0.875rem;
    padding: 0.5rem 0.75rem;
  }
  
  .dashboard-tabs .d-flex {
    flex-wrap: nowrap;
    gap: 0.5rem !important;
  }
}

/* Profile Page Mobile Optimizations */
@media (max-width: 576px) {
  .profile-background {
    height: 150px !important;
  }
  
  .profile-card-body {
    margin-top: -40px !important;
  }
  
  .profile-picture-mobile {
    width: 80px !important;
    height: 80px !important;
  }
  
  .profile-stats .col {
    margin-bottom: 1rem;
  }
  
  .btn-group-mobile .btn {
    font-size: 0.875rem;
    padding: 0.5rem 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,oCAAoC;EACpC,cAAc;EACd;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,0EAA0E;EAC1E,iBAAiB;AACnB;;AAEA,8BAA8B;AAC9B;EACE;sBACoB;AACtB;;AAEA,yBAAyB;AACzB;EACE,oCAAoC;EACpC,gCAAgC;EAChC,4DAA4D;EAC5D,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gDAAgD;AAClD;;AAEA,kBAAkB;AAClB;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,mEAAmE;AACrE;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA,iBAAiB;AACjB;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,oBAAoB;AACpB;EACE,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,cAAc;AACd;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,iCAAiC;AACjC;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oEAA0Q;AAC5Q;;AAEA,mCAAmC;AACnC;EACE;IACE,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,oBAAoB;IACpB,gCAAgC;IAChC,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,uBAAuB;EACzB;AACF;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;AACF","sourcesContent":["/* Dark Theme Styles */\nbody {\n  background-color: #0f1419 !important;\n  color: #ffffff;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.App {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #0f1419 0%, #1a1d29 50%, #2d3343 100%);\n  min-height: 100vh;\n}\n\n/* Authentication Background */\n.auth-background {\n  /* background: linear-gradient(135deg, #0f1419 0%, #1a1d29 50%, #2d3343 100%);\n  min-height: 100vh; */\n}\n\n/* Custom Form Controls */\n.form-control:focus {\n  background-color: #2d3343 !important;\n  border-color: #4f9eff !important;\n  box-shadow: 0 0 0 0.2rem rgba(79, 158, 255, 0.25) !important;\n  color: #fff !important;\n}\n\n.form-control::placeholder {\n  color: #8d99ae !important;\n}\n\n/* Custom Button Styles */\n.btn-primary {\n  background-color: #4f9eff;\n  border-color: #4f9eff;\n}\n\n.btn-primary:hover {\n  background-color: #3d7acc;\n  border-color: #3d7acc;\n}\n\n.btn-primary:focus {\n  box-shadow: 0 0 0 0.2rem rgba(79, 158, 255, 0.5);\n}\n\n/* Navbar Styles */\n.navbar-dark .navbar-nav .nav-link {\n  color: rgba(255, 255, 255, 0.85);\n  transition: color 0.3s ease;\n}\n\n.navbar-dark .navbar-nav .nav-link:hover {\n  color: #4f9eff;\n}\n\n/* Card Hover Effects */\n.card {\n  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n}\n\n.card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);\n}\n\n/* Table Styles */\n.table-dark {\n  --bs-table-bg: #1a1d29;\n  --bs-table-striped-bg: #2d3343;\n  --bs-table-hover-bg: #2d3343;\n}\n\n/* Badge Styles */\n.badge {\n  font-size: 0.75em;\n}\n\n/* Profile Picture Styles */\n.profile-picture-container {\n  position: relative;\n  display: inline-block;\n}\n\n.profile-picture-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n.profile-picture-container:hover .profile-picture-overlay {\n  opacity: 1;\n}\n\n/* Background Image Upload */\n.background-upload-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  cursor: pointer;\n}\n\n.background-image-container:hover .background-upload-overlay {\n  opacity: 1;\n}\n\n/* Modal Styles */\n.modal-content {\n  background-color: #1a1d29 !important;\n  border: 1px solid #2d3343 !important;\n}\n\n.modal-header {\n  border-bottom: 1px solid #2d3343 !important;\n}\n\n.btn-close {\n  filter: invert(1);\n}\n\n/* Username Validation Styles */\n.username-input-success {\n  border-color: #28a745 !important;\n}\n\n.username-input-error {\n  border-color: #dc3545 !important;\n}\n\n/* Loading Spinner */\n.spinner-border-light {\n  border-color: rgba(255, 255, 255, 0.25);\n  border-right-color: #4f9eff;\n}\n\n/* Profile Stats */\n.profile-stats {\n  padding: 1rem 0;\n  border-top: 1px solid #2d3343;\n  border-bottom: 1px solid #2d3343;\n}\n\n.profile-stat {\n  text-align: center;\n  padding: 0 1rem;\n}\n\n.profile-stat h5 {\n  margin-bottom: 0.25rem;\n  font-weight: bold;\n}\n\n.profile-stat small {\n  color: #8d99ae;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .navbar-brand {\n    font-size: 1rem;\n  }\n  \n  .card-body {\n    padding: 1rem;\n  }\n  \n  h2 {\n    font-size: 1.5rem;\n  }\n\n  .profile-picture-container img {\n    width: 100px !important;\n    height: 100px !important;\n  }\n\n  .background-image-container {\n    height: 150px !important;\n  }\n}\n\n/* Animation */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.card, .alert {\n  animation: fadeIn 0.5s ease-out;\n}\n\n/* Custom Scrollbar */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #1a1d29;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #4f9eff;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #3d7acc;\n}\n\n/* File Input Styling */\n.form-control[type=\"file\"] {\n  background-color: #2d3343 !important;\n  border-color: #4f9eff !important;\n  color: #fff !important;\n}\n\n.form-control[type=\"file\"]::-webkit-file-upload-button {\n  background-color: #4f9eff;\n  border: none;\n  color: white;\n  padding: 0.375rem 0.75rem;\n  border-radius: 0.375rem;\n  margin-right: 0.75rem;\n  cursor: pointer;\n}\n\n.form-control[type=\"file\"]::-webkit-file-upload-button:hover {\n  background-color: #3d7acc;\n  border-color: #3d7acc;\n}\n\n/* Navigation Responsive Styles */\n.navbar-toggler {\n  border: none !important;\n  padding: 0.25rem 0.5rem;\n}\n\n.navbar-toggler:focus {\n  box-shadow: none !important;\n}\n\n.navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%2879, 158, 255, 1%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\") !important;\n}\n\n/* Mobile Navigation Improvements */\n@media (max-width: 991.98px) {\n  .navbar-collapse {\n    background-color: #1a1d29;\n    padding: 1rem;\n    margin-top: 0.5rem;\n    border-radius: 8px;\n    border: 1px solid #2d3343;\n  }\n  \n  .navbar-nav {\n    padding-bottom: 1rem;\n    border-bottom: 1px solid #2d3343;\n    margin-bottom: 1rem;\n  }\n  \n  .navbar-nav .nav-link {\n    padding: 0.75rem 1rem;\n    border-radius: 6px;\n    margin-bottom: 0.25rem;\n  }\n  \n  .navbar-nav .nav-link:hover {\n    background-color: #2d3343;\n  }\n  \n  .navbar-nav .nav-link.fw-bold {\n    background-color: #4f9eff;\n    color: white !important;\n  }\n}\n\n/* Dashboard Tab Navigation */\n.dashboard-tabs {\n  overflow-x: auto;\n  white-space: nowrap;\n  -webkit-overflow-scrolling: touch;\n}\n\n.dashboard-tabs::-webkit-scrollbar {\n  height: 4px;\n}\n\n.dashboard-tabs::-webkit-scrollbar-track {\n  background: #1a1d29;\n}\n\n.dashboard-tabs::-webkit-scrollbar-thumb {\n  background: #4f9eff;\n  border-radius: 4px;\n}\n\n@media (max-width: 768px) {\n  .dashboard-tabs .btn {\n    white-space: nowrap;\n    min-width: auto;\n    font-size: 0.875rem;\n    padding: 0.5rem 0.75rem;\n  }\n  \n  .dashboard-tabs .d-flex {\n    flex-wrap: nowrap;\n    gap: 0.5rem !important;\n  }\n}\n\n/* Profile Page Mobile Optimizations */\n@media (max-width: 576px) {\n  .profile-background {\n    height: 150px !important;\n  }\n  \n  .profile-card-body {\n    margin-top: -40px !important;\n  }\n  \n  .profile-picture-mobile {\n    width: 80px !important;\n    height: 80px !important;\n  }\n  \n  .profile-stats .col {\n    margin-bottom: 1rem;\n  }\n  \n  .btn-group-mobile .btn {\n    font-size: 0.875rem;\n    padding: 0.5rem 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
